(() => {
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  if (!('IntersectionObserver' in window)) return;

  const prepared = new WeakSet();
  const selector = 'h1, h2, h3, p, img';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);
      if (reducedMotion.matches) return;

      // Avoid overlapping with existing SBS reveals.
      if (entry.target.closest('.sbs, .sbs-r')) return;

      const siblings = Array.from(
        entry.target.parentElement.children
      ).filter((element) => element.matches(selector));

      const index = Math.max(0, siblings.indexOf(entry.target));

      entry.target.animate(
        [
          { opacity: 0, transform: 'translateY(34px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        {
          duration: 950,
          delay: Math.min(index, 6) * 110,
          easing: 'cubic-bezier(0.2, 0.75, 0.2, 1)',
          fill: 'backwards'
        }
      );
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08
  });

  function prepareContent() {
    if (reducedMotion.matches) return;

    document.querySelectorAll(
      'main .shopify-section h1, ' +
      'main .shopify-section h2, ' +
      'main .shopify-section h3, ' +
      'main .shopify-section p, ' +
      'main .shopify-section img'
    ).forEach((element) => {
      if (prepared.has(element)) return;

      if (element.closest(
        '.sbs, .sbs-r, [data-no-site-motion], ' +
        'slideshow-component, slideshow-slides'
      )) return;

      prepared.add(element);
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareContent);
  } else {
    prepareContent();
  }

  document.addEventListener('shopify:section:load', prepareContent);
})();
